<template>
  <Modal :title="'Impianto di destinazione'" :openModal="true" @close="closeModal" @success="saveTransfer()" :loading="loadingSave">
    <div class="columns is-multiline">

      <div class="column is-12">
        <InputSelect
          name="Proprietario"
          v-model="transferDestination.client"
          :options="clients"
          :loading="waitClients"
          :disabled="disableClient || !$store.getters.amAdmin"
          id="_id"
          track-by="_id"
          :custom-label="$clientName"
          @select="changeClient"
          @remove="changeClient(false)"
        >
          <a class="button is-warning" :href="transferDestination.client ? '/clienti/'+transferDestination.client._id : 'javascript:void(0)'" target="_blank"><font-awesome-icon icon="user" class="m-0" /></a>
        </InputSelect>
      </div>

      <div class="column is-12">
        <InputSelect
          name="Occupante"
          v-model="transferDestination.occupant"
          :options="clients"
          :loading="waitClients"
          :disabled="disableOccupant || !$store.getters.amAdmin"
          id="_id"
          track-by="_id"
          :custom-label="$clientName"
          @select="changeOccupant"
          @remove="changeOccupant(false)"
        >
          <a class="button is-warning" :href="transferDestination.occupant ? '/clienti/'+transferDestination.occupant._id : 'javascript:void(0)'" target="_blank"><font-awesome-icon icon="user" class="m-0" /></a>
        </InputSelect>
      </div>

      <div class="column is-12">
        <InputSelect
          name="Luogo"
          v-model="transferDestination.place"
          :options="places"
          :loading="waitPlaces"
          :disabled="!transferDestination.client || !$store.getters.amAdmin"
          id="_id"
          track-by="_id"
          :custom-label="$placeName"
          :allowEmpty="false"
          @select="changePlace"
          @remove="changePlace(false)"
        >
          <a class="button is-warning" :href="transferDestination.place ? '/luoghi/'+transferDestination.place._id : 'javascript:void(0)'" target="_blank"><font-awesome-icon icon="building" class="m-0" /></a>
        </InputSelect>
      </div>

      <div class="column is-12">
        <InputSelect
          name="Impianto"
          v-model="transferDestination.implant"
          :options="implants"
          :loading="waitImplants"
          :disabled="!transferDestination.place || !$store.getters.amAdmin"
          id="_id"
          track-by="_id"
          :custom-label="$implantName"
          :allowEmpty="false"
          @select="changeImplant"
          @remove="changeImplant(false)"
        >
          <a class="button is-warning" :href="transferDestination.implant ? '/impianti/'+transferDestination.implant._id : 'javascript:void(0)'" target="_blank"><font-awesome-icon icon="temperature-arrow-up" class="m-0" /></a>
        </InputSelect>
      </div>

    </div>
  </Modal>
</template>

<script>
import utils from '../../utils'

export default {
  props: {
    element: Object,
    loadingSave: Boolean
  },
  emits: ['close', 'save'],

  data() {
    return {
      //selectedElement: null,
      //loadingSave: false,

      transferDestination: {
        client: null,
        occupant: null,
        place: null,
        implant: null
      },

      clients: [],
      places: [],
      implants: [],
      waitClients: true,
      waitPlaces: false,
      waitImplants: false,
      disableClient: false,
      disableOccupant: false
    }
  },

  methods: {
    closeModal() {
      this.$emit('close')
    },

    saveTransfer() {
      this.$emit('save', this.transferDestination.implant._id)
    },

    changeClient(client) {
      this.transferDestination.occupant = null
      this.transferDestination.place = null
      this.transferDestination.implant = null

      if (client) {
        this.disableOccupant = true

        this.getPlaces(client, 'client')
      } else {
        this.disableOccupant = false
      }
    },

    changeOccupant(occupant) {
      this.transferDestination.client = null
      this.transferDestination.place = null
      this.transferDestination.implant = null

      if (occupant) {
        this.disableClient = true

        this.getPlaces(occupant, 'occupant')
      } else {
        this.disableClient = false
      }
    },

    changePlace(place) {
      this.transferDestination.implant = null

      this.getImplants(place)
    },

    changeImplant(implant) {
      this.transferDestination.client = implant.client
      this.transferDestination.occupant = implant.occupant
    },

    getPlaces(contact, type = 'client') {
      const self = this
      self.waitPlaces = true

      let query = ''
      if (type === 'client') {
        query = '/place/client-from-implant/' + contact._id
      } else if (type === 'occupant') {
        query = '/place/occupant-from-implant/' + contact._id
      }

      this.$http.get(query)
      .then(function (response) {
        if (response && response.data) {
          self.places = response.data
          if (self.places?.length === 1) {
            self.transferDestination.place = self.places[0]
            self.changePlace(self.places[0])
          }
        }
        self.waitPlaces = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },

    getImplants(place) {
      const self = this
      self.waitImplants = true

      this.$http.get('/implant', { params: {page: 1, size: -1, place_id: place._id} })
      .then(function (response) {
        if (response && response.data) {
          self.implants = response.data.records
          if (self.implants?.length === 1) {
            self.transferDestination.implant = self.implants[0]
            self.changeImplant(self.implants[0])
          }
        }
        self.waitImplants = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
    },
  },

  mounted() {
    const self = this

    utils.fetchClients(this.$http)
      .then(function (clients) {
        self.clients = clients
        self.waitClients = false
      })
      .catch(function (error) {
        console.log(error)
        alert('Errore')
      })
  }
}
</script>